// Copyright 2023 Anthony Howell. All rights reserved.
import { observer } from 'mobx-react';
import ViewModel from './core/ViewModel';
import './ActionButtonsView.scss';
import ShareHandView from './ShareHandView';

interface ActionButtonsViewProps {
  viewModel: ViewModel;
}

const ActionButtonsView = observer(({ viewModel }: ActionButtonsViewProps) => {
  const handleClearAllClick = () => {
    viewModel.clearAllCards();
  };

  const handleRunSimsClick = () => {
    viewModel.runSims();
    viewModel.setSelectedComponent(null);
  };

  const handleMenuClick = () => {
    viewModel.toggleMenu();
  };

  return (
    <div className="action-buttons">
      {viewModel.isSimulating ? (
        <div className="calculating-animation">
          <div className="spinner"></div>
          <span>Calculating...</span>
        </div>
      ) : (
        <>
          <button
            className="clear-all-button"
            onClick={handleClearAllClick}
            disabled={viewModel.isSimulating}
          >
            Clear All
          </button>
          <button
            className="menu-button"
            onClick={handleMenuClick}
            disabled={viewModel.isSimulating}
          >
            Settings
          </button>
          <button
            className="run-sims-button"
            onClick={handleRunSimsClick}
            disabled={viewModel.isSimulating}
          >
            Calculate
          </button>
          <ShareHandView viewModel={viewModel} />
        </>
      )}
    </div>
  );
});

export default ActionButtonsView;
